import React from 'react';
import { checkCurrency, roundOff, roundingOff, shortenStringWithTooltip } from '../../../../../../Components/helper';
import useShowHideSectionHooks from '../../Hooks/useShowHideSectionHooks';

export function GranTotalDetailCostingExapandView({ expandData, index, expandGrandTotalChild, isExpanded, colourway, sizeRange, lengthRange, productInfoObj }) {
  const { productCostingstate } = productInfoObj;
  const { hideLengthCol } = useShowHideSectionHooks(productInfoObj);
  const {
    productInfo: { currency },
    isBreakdown,
  } = productCostingstate;

  return (
    <>
      {expandData.map((data, chindex) => {
        return (
          <tr key={index}>
            {chindex === 0 && !isBreakdown ? (
              <td className="text-right">
                {isExpanded ? (
                  <button
                    className="btn-up-down"
                    onClick={() => {
                      expandGrandTotalChild(index);
                    }}
                  >
                    <span className="icon-new-down-arrow-icon icon-inverse" />
                  </button>
                ) : (
                  <button
                    className="btn-up-down"
                    onClick={() => {
                      expandGrandTotalChild(index);
                    }}
                  >
                    <span className="icon-new-down-arrow-icon " />
                  </button>
                )}
              </td>
            ) : (
              <td />
            )}
            <td>
              <b>{colourway?.name}</b>
            </td>
            <td> {isBreakdown ? Array.isArray(sizeRange) && shortenStringWithTooltip(sizeRange?.map((e) => e?.name).join(' - '), 15) : data?.size || ''}</td>
            {hideLengthCol && (
              <td>
                {' '}
                {isBreakdown
                  ? Array.isArray(lengthRange) && shortenStringWithTooltip(lengthRange?.map((e) => e?.name).join(' - '), 15)
                  : data?.length?.name || ''}
              </td>
            )}
            <td className="text-right">{roundOff(data?.quantityPerSizCol, 4, true)}</td>
            <td className="text-right">{roundOff(data?.pricePerUnit, 4, true)}</td>
            <td className="text-right">
              {checkCurrency(currency, data?.totalPrice)} {roundingOff(data?.totalPrice, 2, true)}
            </td>
          </tr>
        );
      })}
    </>
  );
}

export default GranTotalDetailCostingExapandView;
